import React, { useContext } from 'react';
import { VisitedNodeContext } from '../../CreateQuestionnaire';
import GroupElement from '../SectionElement/GroupElement';
import styles from './Section.module.css';

function Group({ groupIdArray, data, parentId }) {
  // `visited` is the shared context object, mutated in place below. React 19
  // warns on the old no-op `setVisitedContext(visited)` (setState during render
  // with the same reference), so drop the setter — the in-place mutation stands.
  const [visitedContext] = useContext(VisitedNodeContext);
  return (
    <div className={styles.GroupColumn}>
      {groupIdArray.map((groupId, index) => {
        let visited = visitedContext;
        visited[groupId.id] = visited[groupId.id] ? visited[groupId] + 1 : 0;
        if (visited[groupId.id] === 2)
          return (
            <React.Fragment
              key={`${groupId.id}_${index}_skip`}
            ></React.Fragment>
          );
        const children = data[`${groupId.id}`].groupsConnectedTo;
        const hasChildren = children && children.length > 0;
        const isSectionParent = data[`${groupId.id}`].formType === false;
        return (
          <React.Fragment key={`${groupId.id}`}>
            <div className={styles.GroupNode}>
              <GroupElement
                groupId={groupId.id}
                data={data[`${groupId.id}`]}
                parentId={parentId}
                index={index}
              />
              {hasChildren && (
                <div
                  className={
                    isSectionParent ? styles.FlatBranch : styles.NestedBranch
                  }
                >
                  <Group
                    groupIdArray={children}
                    data={data}
                    parentId={groupId.id}
                  />
                </div>
              )}
            </div>
          </React.Fragment>
        );
      })}
    </div>
  );
}

export default Group;
